<template>
    <section id="contacto" class="sp-section sp-contacto-section">
        <!-- Orbe de luz ambiental -->
        <div class="sp-glow-orb sp-glow-orb--orange" style="bottom: 10%; left: -5%; width: 450px; height: 450px;"></div>

        <div class="sp-container">
            <div class="sp-section-head sp-reveal">
                <span class="sp-eyebrow">Contacto Comercial</span>
                <h2 class="sp-h2">¿Tienes dudas o requieres asesoría? Hablemos</h2>
                <p class="sp-lead">
                    Cuéntanos sobre tu establecimiento comercial y un asesor especializado te explicará
                    cómo activar tus campañas en ruta.
                </p>
            </div>

            <div class="sp-contacto">
                <div class="sp-contacto__datos sp-reveal sp-delay-1">
                    <h3 class="sp-h3">Canales de atención directa</h3>
                    <p class="sp-contacto__intro">
                        Comunícate con nuestro equipo comercial para resolver inquietudes técnicas o comerciales sobre Seway Plus Negocios.
                    </p>

                    <ul class="sp-contacto__lista">
                        <li class="sp-contacto__item sp-contacto__item--wa">
                            <span class="sp-icon-badge">
                                <i class="pi pi-whatsapp" aria-hidden="true"></i>
                            </span>
                            <a :href="urlWhatsapp" target="_blank" rel="noopener noreferrer">
                                <strong>WhatsApp Comercial</strong>
                                <span>(+57) 316 471 1351</span>
                            </a>
                        </li>
                        <li class="sp-contacto__item sp-contacto__item--email">
                            <span class="sp-icon-badge">
                                <i class="pi pi-envelope" aria-hidden="true"></i>
                            </span>
                            <a href="mailto:directorcomercial@setic.co">
                                <strong>Correo Electrónico</strong>
                                <span>directorcomercial@setic.co</span>
                            </a>
                        </li>
                        <li class="sp-contacto__item sp-contacto__item--dir">
                            <span class="sp-icon-badge">
                                <i class="pi pi-map-marker" aria-hidden="true"></i>
                            </span>
                            <div>
                                <strong>Sede Principal</strong>
                                <span>CLL. 85 # 48-01, Itagüí, Antioquia, Colombia</span>
                            </div>
                        </li>
                    </ul>

                    <div class="sp-contacto__cta-caja">
                        <p>¿Listo para autogestionar tu cuenta?</p>
                        <button type="button" class="sp-btn sp-btn--outline" @click="$emit('anunciarme')">
                            <span>Crear mi cuenta ahora</span>
                            <i class="pi pi-arrow-right" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>

                <div class="sp-contacto__form-wrap sp-reveal sp-delay-2">
                    <FormularioContacto titulo="Déjanos un mensaje" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import FormularioContacto from './FormularioContacto';

export default {
    name: 'NegociosContacto',
    emits: ['anunciarme'],
    components: { FormularioContacto },
    data() {
        return {
            urlWhatsapp: 'https://api.whatsapp.com/send/?phone=573164711351'
        };
    }
};
</script>

<style lang="scss" scoped>
.sp-contacto-section {
    position: relative;
    overflow: hidden;
}

.sp-contacto {
    display: grid;
    grid-template-columns: 1fr;
    gap: clamp(2rem, 4vw, 3.5rem);
    align-items: start;
}

.sp-contacto__datos {
    display: flex;
    flex-direction: column;
}

.sp-contacto__intro {
    margin-top: 0.5rem;
    color: var(--sp-text-soft);
    font-size: 0.96rem;
    line-height: 1.6;
}

.sp-contacto__lista {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    margin: 1.75rem 0 2rem;
}

.sp-contacto__item {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.1rem 1.25rem;
    background: #ffffff;
    border: 1px solid var(--sp-border);
    border-radius: var(--sp-radius);
    box-shadow: var(--sp-shadow-sm);
    transition: transform var(--sp-transition-fast), box-shadow var(--sp-transition-fast), border-color var(--sp-transition-fast);

    &:hover {
        transform: translateX(6px);
        border-color: rgba(235, 93, 27, 0.4);
        box-shadow: 0 10px 25px rgba(13, 48, 68, 0.08);
    }

    a,
    div {
        display: flex;
        flex-direction: column;
        min-width: 0;
    }

    strong {
        color: var(--sp-navy);
        font-size: 1rem;
        font-weight: 700;
    }

    span {
        color: var(--sp-text-soft);
        font-size: 0.92rem;
        overflow-wrap: anywhere;
        margin-top: 0.15rem;
    }
}

.sp-contacto__item--wa:hover {
    .sp-icon-badge {
        background: #22c55e;
        color: #fff;
    }
}

.sp-contacto__item--email:hover {
    .sp-icon-badge {
        background: var(--sp-navy);
        color: #fff;
    }
}

.sp-contacto__item--dir:hover {
    .sp-icon-badge {
        background: var(--sp-orange);
        color: #fff;
    }
}

.sp-contacto__cta-caja {
    padding: 1.25rem 1.5rem;
    background: var(--sp-surface-alt);
    border-radius: var(--sp-radius);
    border: 1px solid var(--sp-border);

    p {
        color: var(--sp-navy);
        font-size: 0.92rem;
        font-weight: 700;
        margin-bottom: 0.75rem;
    }
}

@media (min-width: 992px) {
    .sp-contacto {
        grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
    }
}

/* Sin tope, a 2560 el formulario llegaba a ~900px de ancho: campos demasiado
   largos para leerlos y rellenarlos con comodidad. */
@media (min-width: 2000px) {
    .sp-contacto {
        max-width: 1400px;
        margin: 0 auto;
    }
}
</style>
